
import React from "react";
import { Gavel } from "lucide-react";

const HeroSection: React.FC = () => {
  return (
    <div className="flex flex-col md:flex-row items-center gap-8 mb-12">
      <div className="md:w-1/2 space-y-3">
        <div className="flex items-center gap-3 mb-4">
          <div className="bg-heaven-gold/10 p-3 rounded-full">
            <Gavel className="h-6 w-6 text-heaven-dark-gold" />
          </div>
          <h2 className="text-3xl font-playfair font-bold text-heaven-gold">
            Moral & Ethical Dilemmas
          </h2>
        </div>
        
        <h3 className="text-2xl font-playfair font-bold text-gray-800">
          When right and wrong collide, the Word stands firm.
        </h3>
        
        <p className="text-lg text-gray-700">
          Selah helps you navigate today's hardest moral questions with truth, courage, and grace.
        </p>
        
        <p className="text-gray-700 text-sm">
          We're living in a world that redefines everything—gender, sexuality, marriage, truth itself. 
          But God's Word hasn't changed. The Moral & Ethical Dilemmas Tool gives you biblically grounded 
          responses to real-life situations where compromise is common—but faithfulness is required.
        </p>
      </div>
      <div className="md:w-1/2">
        <img 
          src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//moral%20dilemma%202.png" 
          alt="Biblical Guidance on Moral Dilemmas" 
          className="rounded-lg shadow-md w-full object-cover"
        />
      </div>
    </div>
  );
};

export default HeroSection;
